import { Angulartics2 } from 'angulartics2';
import { Injectable } from '@angular/core';
import { ampli } from '../ampli';

/**
 * Angulartics2 provider for Amplitude.
 */
@Injectable({ providedIn: 'root' })
export class Angulartics2AmplitudePSTG {
    constructor(private readonly angulartics2: Angulartics2) {}

    startTracking(): void {
        this.angulartics2.eventTrack.pipe(this.angulartics2.filterDeveloperMode()).subscribe(x => {
            this.eventTrack(x.action, x.properties);
        });
    }

    pageTrack(path: string, urlParams: string = ''): void {
        try {
            this.eventTrack('Pageview', {
                url: path,
                urlParams: urlParams,
            });
        } catch (e) {
            if (!(e instanceof ReferenceError)) {
                // Ignore errors due to Amplitude not being available/loaded yet (just in case...)
                throw e;
            }
        }
    }

    eventTrack(action: string, properties: any): void {
        try {
            ampli.track(action as any, { event_properties: properties } as any);
        } catch (e) {
            if (!(e instanceof ReferenceError)) {
                throw e;
            }
        }
    }
}
